import * as Types from '../../../__generated__/types.js'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type AppearanceQueryVariables = Types.Exact<{ [key: string]: never }>

export type AppearanceQuery = {
    __typename: 'Query'
    appearance?:
        | {
              __typename: 'Appearance'
              appName?: string | null | undefined
              themeColor?: string | null | undefined
              lightColor?: string | null | undefined
              darkColor?: string | null | undefined
          }
        | null
        | undefined
}

export const AppearanceDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Appearance' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appearance' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'appName' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'themeColor' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lightColor' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'darkColor' }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
} as unknown as DocumentNode

/**
 * __useAppearanceQuery__
 *
 * To run a query within a React component, call `useAppearanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppearanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppearanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppearanceQuery(
    baseOptions?: Apollo.QueryHookOptions<
        AppearanceQuery,
        AppearanceQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<AppearanceQuery, AppearanceQueryVariables>(
        AppearanceDocument,
        options
    )
}
export function useAppearanceLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        AppearanceQuery,
        AppearanceQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<AppearanceQuery, AppearanceQueryVariables>(
        AppearanceDocument,
        options
    )
}
export type AppearanceQueryHookResult = ReturnType<typeof useAppearanceQuery>
export type AppearanceLazyQueryHookResult = ReturnType<
    typeof useAppearanceLazyQuery
>
export type AppearanceQueryResult = Apollo.QueryResult<
    AppearanceQuery,
    AppearanceQueryVariables
>
